<template>
  <div class="date-pick__sidebar">
    <t-button v-for="(item, index) in selfShortcuts"
              :key="index" class="btn-block mb-2" type="secondary" @click.stop="$_onButtonsClick(item.onClick)">{{ item.text }}</t-button>
  </div>
</template>
<script>
import moment from 'moment'
import locale from '../../../mixins/locale'

export default {
  name: 'TShortcutsAside',
  mixins: [locale],
  props: {
    isRange: Boolean,
    shortcutOptions: {
      type: Object
    }
  },
  data: function() {
    return {
      selfShortcuts: []
    }
  },
  created() {
    this.initShortcuts()
  },
  methods: {
    $_onButtonsClick(onClick) {
      if (onClick) {
        onClick(this)
      }
    },
    getDefaultShortcuts() {
      let shortcuts = []
      if (this.isRange === true) {
        shortcuts.push({
          text: this.t('t.datepicker.inLastWeek'),
          onClick(picker) {
            picker.$emit('shortcut-pick', [moment().subtract(1, 'w'), moment()])
          }
        })
        shortcuts.push({
          text: this.t('t.datepicker.inLastMonth'),
          onClick(picker) {
            picker.$emit('shortcut-pick', [moment().subtract(1, 'M'), moment()])
          }
        })
      } else {
        shortcuts.push({
          text: this.t('t.datepicker.lastWeek'),
          onClick(picker) {
            picker.$emit('shortcut-pick', moment().subtract(1, 'w'))
          }
        })
        shortcuts.push({
          text: this.t('t.datepicker.lastMonth'),
          onClick(picker) {
            picker.$emit('shortcut-pick', moment().subtract(1, 'M'))
          }
        })
        shortcuts.push({
          text: this.t('t.datepicker.nextWeek'),
          onClick(picker) {
            picker.$emit('shortcut-pick', moment().add(1, 'w'))
          }
        })
        shortcuts.push({
          text: this.t('t.datepicker.prevYear'),
          onClick(picker) {
            picker.$emit('shortcut-pick', moment().subtract(1, 'y'))
          }
        })
        shortcuts.push({
          text: this.t('t.datepicker.nextMonth'),
          onClick(picker) {
            picker.$emit('shortcut-pick', moment().add(1, 'M'))
          }
        })
        shortcuts.push({
          text: this.t('t.datepicker.nextYear'),
          onClick(picker) {
            picker.$emit('shortcut-pick', moment().add(1, 'y'))
          }
        })
      }

      return shortcuts
    },
    initShortcuts() {
      if (!this.shortcutOptions || !this.shortcutOptions.shortcuts) {
        this.selfShortcuts = this.getDefaultShortcuts()
      } else {
        if (this.shortcutOptions.isCover === true) {
          // 覆盖默认
          this.selfShortcuts = this.shortcutOptions.shortcuts
        } else {
          // 合并
          this.selfShortcuts = this.shortcutOptions.shortcuts.concat(
            this.getDefaultShortcuts()
          )
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// shortcuts-aside.vue?079cf30c